import"react";import{c as r}from"./createSvgIcon-7d989ad9.js";import{jsx as o}from"react/jsx-runtime";var t=r(o("path",{d:"M7 10l5 5 5-5z"}),"ArrowDropDown");export{t as A};
